import $ from 'jquery'; 

function heroSlick(){
   $( '.slick' ).slick({
        arrows: true,
        dots: true,
       // autoplay: true,
       autoplay: false,
        pauseOnHover: true,
        useTransform: false,
        cssEase: 'ease-out'
	});
   return (null)
}
export default heroSlick